import { getConfig } from '../../utils/client-config';
import { logout } from '../../window-utils/logout';
import { addDeviceAppIdHeader, addPcUserIdHeader, addXScreenDimensionHeader, appVersion, hostWebviewApplicationId, originApplicationId, os, signWebview, timezoneOffset, xb3TraceId, xcsrfToken, } from './extensions';
import { initApi } from './init-api';
/**
 * Создаёт клиентскую api на основе декларации
 * @param apiDeclaration Декларация
 * @param config Дополнительная конфигурация api
 */
export function initClientApi(apiDeclaration, { getConfigExtenders }) {
    return initApi(apiDeclaration, {
        getConfigExtenders: (extenders) => getConfigExtenders(extenders
            .add(xb3TraceId)
            .add(xcsrfToken)
            .add(timezoneOffset)
            .add(originApplicationId(getConfig()?.appId))
            .add(hostWebviewApplicationId)
            .add(signWebview)
            .add(os)
            .add(appVersion)
            .add(addDeviceAppIdHeader)
            .add(addPcUserIdHeader)
            .add(addXScreenDimensionHeader)),
        resultHandlers: [
            (result) => {
                if (result?.request?.responseURL?.includes('private.auth.alfabank.ru/passport/cerberus')) {
                    logout('SessionIsExpired');
                }
                return result;
            },
        ],
        useBrowserLogger: true,
    });
}
